import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ScrollToTop } from '../common/ScrollToTop';
import { ScrollRestoration } from '../common/ScrollRestoration';

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollRestoration />
      <Navbar />
      {/* Main content - no padding needed, Hero handles its own spacing */}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
